'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _EntityScope = require('./EntityScope');

var _EntityScope2 = _interopRequireDefault(_EntityScope);

require('./RuleSettings.scss');

var _constants = require('../../../../constants');

var _helpers = require('../../../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var TabPane = _antd.Tabs.TabPane;
var Option = _antd.Select.Option;
var RangePicker = _antd.DatePicker.RangePicker;

var forIn = require('lodash/object/forIn');

var RuleSettings = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RuleSettings, _Component);

  function RuleSettings(props) {
    (0, _classCallCheck3.default)(this, RuleSettings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RuleSettings.__proto__ || (0, _getPrototypeOf2.default)(RuleSettings)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      modalVisible: false,
      submitEntityScopeForm: false,
      entityScopeFormIsValid: null
    };
    _this.initializeForm();
    return _this;
  }

  (0, _createClass3.default)(RuleSettings, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.initializeForm();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var getFieldDecorator = this.props.form.getFieldDecorator;
      var _props = this.props,
          scopeEntityType = _props.scopeEntityType,
          selectedEntityIds = _props.selectedEntityIds,
          currentAdvertiser = _props.currentAdvertiser,
          ruleset = _props.ruleset;
      var _props$ruleSettings = this.props.ruleSettings,
          aggregationLevel = _props$ruleSettings.aggregationLevel,
          dataRangeRelative = _props$ruleSettings.dataRangeRelative,
          scheduleType = _props$ruleSettings.scheduleType;

      var entityScopeMessage = (0, _helpers.generateEntitySelectedMsg)(aggregationLevel, scopeEntityType, selectedEntityIds, currentAdvertiser.name);

      var errorBadge = !this.isFormValid() || this.state.entityScopeFormIsValid === false ? _react2.default.createElement(_antd.Badge, { className: 'pane-error-badge', count: '!' }) : null;

      var disabledDate = function disabledDate(current) {
        return current && (_momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() > _momentTimezone2.default.tz(ruleset.endTime, ruleset.timezone).startOf('day').valueOf() || _momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() < (0, _momentTimezone2.default)().tz(ruleset.timezone).startOf('day').valueOf() || _momentTimezone2.default.tz(current, ruleset.timezone).startOf('day').valueOf() < _momentTimezone2.default.tz(ruleset.startTime, ruleset.timezone).startOf('day').valueOf());
      };

      return _react2.default.createElement(
        'div',
        { className: 'ruleSettings__component' },
        _react2.default.createElement(
          _antd.Tabs,
          null,
          _react2.default.createElement(
            TabPane,
            { tab: _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.label', defaultMessage: 'Rule Settings' }),
                ' ',
                errorBadge
              ), key: '1' },
            _react2.default.createElement(
              _antd.Form,
              { layout: 'vertical', hideRequiredMark: true },
              _react2.default.createElement(
                _antd.Row,
                null,
                _react2.default.createElement(
                  _antd.Col,
                  { span: 4, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.ruleName.label', defaultMessage: 'Rule Name' }),
                      className: 'warning-field'
                    },
                    getFieldDecorator('name', {
                      rules: [{ required: true, message: 'Missing Rule Name', whitespace: true }]
                    })(_react2.default.createElement(_antd.Input, { placeholder: "Enter a rule name" }))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 4, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.frequency.label', defaultMessage: 'Check conditions every:' })
                    },
                    getFieldDecorator('frequency')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.FREQUENCIES.map(function (frequency) {
                        return _react2.default.createElement(
                          Option,
                          { key: frequency.value, value: frequency.value },
                          frequency.label
                        );
                      })
                    ))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 3, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.schedule.label', defaultMessage: 'Schedule' })
                    },
                    getFieldDecorator('scheduleType')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.RULE_SCHEDULE.map(function (option) {
                        return _react2.default.createElement(
                          Option,
                          { key: option.value, value: option.value },
                          option.label
                        );
                      })
                    ))
                  )
                ),
                scheduleType === 'SET_SCHEDULE' && _react2.default.createElement(
                  _antd.Col,
                  { span: 4, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.selectDates.label', defaultMessage: 'Select Dates' }),
                        ' ',
                        this.scheduleFieldTooltip
                      )
                    },
                    getFieldDecorator('schedule', {
                      rules: [{ required: scheduleType === 'SET_SCHEDULE', message: 'Missing date range' }]
                    })(_react2.default.createElement(RangePicker, {
                      style: { width: '100%' },
                      showTime: {
                        defaultValue: [(0, _momentTimezone2.default)('00:00:00', 'HH:mm:ss'), (0, _momentTimezone2.default)('23:59:59', 'HH:mm:ss')]
                      },
                      format: 'MMM-DD-YY',
                      allowClear: true,
                      disabledDate: disabledDate,
                      disabledTime: function disabledTime(selectedDates, type) {
                        return (0, _helpers.disableTimeRange)(selectedDates, type, ruleset.startTime, ruleset.endTime, ruleset.timezone);
                      }
                    }))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 3, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.status.label', defaultMessage: 'Status' })
                    },
                    getFieldDecorator('status')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.STATUS.map(function (status) {
                        return _react2.default.createElement(
                          Option,
                          { key: status.value, value: status.value },
                          status.label
                        );
                      })
                    ))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 4, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.ruleSettingsTab.selectEntities.label', defaultMessage: 'Scope' })
                    },
                    _react2.default.createElement(
                      _antd.Button,
                      {
                        className: 'select-entities-btn',
                        onClick: function onClick() {
                          return _this2.toggleModal();
                        }
                      },
                      _react2.default.createElement(_antd.Icon, { type: 'plus' }),
                      _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'ruleSettings.openSelectEntities.button',
                        defaultMessage: 'Select Campaigns'
                      })
                    ),
                    _react2.default.createElement(
                      _antd.Modal,
                      {
                        title: 'Choose what this Rule applies to',
                        visible: this.state.modalVisible,
                        onCancel: this.toggleModal,
                        width: 900,
                        maskClosable: false,
                        footer: [_react2.default.createElement(
                          _antd.Button,
                          { key: 'cancel', onClick: function onClick() {
                              return _this2.toggleModal();
                            } },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'ruleSettings.entityScopeModal.cancel.button.label',
                            defaultMessage: 'Cancel'
                          })
                        ), _react2.default.createElement(
                          _antd.Button,
                          { key: 'submit', type: 'primary', onClick: function onClick() {
                              return _this2.submitEntityScopeForm();
                            } },
                          _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'ruleSettings.entityScopeModal.confirm.button.label',
                            defaultMessage: 'Ok'
                          })
                        )]
                      },
                      _react2.default.createElement(_EntityScope2.default, {
                        entityHierarchy: this.props.entityHierarchy,
                        currentAdvertiser: this.props.currentAdvertiser,
                        aggregationLevel: this.props.ruleSettings.aggregationLevel,
                        scopeEntityType: this.props.scopeEntityType,
                        selectedEntityIds: this.props.selectedEntityIds,
                        onEntityScopeFormSubmit: this.onEntityScopeFormSubmit,
                        submitEntityScopeForm: this.state.submitEntityScopeForm,
                        ruleSettingsActions: this.props.ruleSettingsActions
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _antd.Row,
                null,
                _react2.default.createElement(
                  _antd.Col,
                  { span: 24 },
                  _react2.default.createElement(
                    'div',
                    { className: 'entity-scope-message' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'ruleSettings.entityScopeMessage',
                      defaultMessage: 'Currently affecting: {entityScopeMessage}',
                      values: { entityScopeMessage: entityScopeMessage }
                    })
                  )
                )
              ),
              _react2.default.createElement('hr', null),
              _react2.default.createElement(
                _antd.Row,
                null,
                _react2.default.createElement(
                  _antd.Col,
                  { span: 4, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.dateRange.label', defaultMessage: 'Use data from: ' }),
                        _react2.default.createElement(
                          _antd.Tooltip,
                          {
                            placement: 'top',
                            title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                              id: 'ruleSettings.dataRange.field.tooltip',
                              defaultMessage: 'Data sync occurs every 20 minutes. Expect delays for changes made directly on native publisher tools. Updates made in AdParlor will be available immediately.'
                            })
                          },
                          _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
                        )
                      )
                    },
                    getFieldDecorator('dataRangeRelative')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.DATA_RANGE.map(function (range) {
                        return _react2.default.createElement(
                          Option,
                          { key: range.value, value: range.value },
                          range.label
                        );
                      })
                    ))
                  )
                ),
                dataRangeRelative === 'LAST_N_DAYS' && _react2.default.createElement(
                  _antd.Col,
                  { span: 2, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.nDays.label', defaultMessage: 'Days (n)' })
                    },
                    getFieldDecorator('lastNDays', {
                      rules: [{ required: dataRangeRelative === 'LAST_N_DAYS', message: 'Enter number of days', whitespace: true }],
                      validateTrigger: 'onKeyUp'
                    })(_react2.default.createElement(_antd.InputNumber, {
                      min: 0,
                      style: { width: '100%' }
                    }))
                  )
                ),
                dataRangeRelative === 'DATE_RANGE' && _react2.default.createElement(
                  _antd.Col,
                  { span: 5, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.specificDateRange.label', defaultMessage: 'Select Dates' })
                    },
                    getFieldDecorator('specificDateRange', {
                      rules: [{ required: dataRangeRelative === 'DATE_RANGE', message: 'Missing date range' }]
                    })(_react2.default.createElement(RangePicker, {
                      style: { width: '100%' },
                      format: 'MMM-DD-YY',
                      allowClear: true
                    }))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 3, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.attributionClickWindow.label', defaultMessage: 'Click Attribution' })
                    },
                    getFieldDecorator('attributionClickWindow')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.ATTRIBUTION_CLICK_WINDOW.map(function (clickWindow) {
                        return _react2.default.createElement(
                          Option,
                          { key: clickWindow.value, value: clickWindow.value },
                          clickWindow.label
                        );
                      })
                    ))
                  )
                ),
                _react2.default.createElement(
                  _antd.Col,
                  { span: 3, className: 'rule-setting-form-field-col' },
                  _react2.default.createElement(
                    FormItem,
                    {
                      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ruleSettings.dataRangeTab.attributionViewWindow.label', defaultMessage: 'View Attribution' })
                    },
                    getFieldDecorator('attributionViewWindow')(_react2.default.createElement(
                      _antd.Select,
                      {
                        showSearch: false,
                        style: { width: '100%' }
                      },
                      _constants.ATTRIBUTION_VIEW_WINDOW.map(function (viewWindow) {
                        return _react2.default.createElement(
                          Option,
                          { key: viewWindow.value, value: viewWindow.value },
                          viewWindow.label
                        );
                      })
                    ))
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RuleSettings;
}(_react.Component), _class.propTypes = {
  form: _propTypes2.default.shape({
    getFieldsError: _propTypes2.default.func.isRequired,
    validateFields: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired,
    getFieldValue: _propTypes2.default.func.isRequired,
    setFieldsInitialValue: _propTypes2.default.func.isRequired
  }).isRequired,
  scopeEntityType: _propTypes2.default.oneOf(_constants.ENTITY_SCOPE.map(function (entityScope) {
    return entityScope.value;
  })),
  selectedEntityIds: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
  ruleSettings: _propTypes2.default.shape({
    aggregationLevel: _propTypes2.default.oneOf(_constants.AGGREGATION_LEVELS.map(function (aggregationLevel) {
      return aggregationLevel.value;
    })),
    dataRangeRelative: _propTypes2.default.string,
    scheduleType: _propTypes2.default.string
  }).isRequired,
  ruleSettingsActions: _propTypes2.default.func.isRequired,
  entityHierarchy: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired,
      children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string.isRequired,
          label: _propTypes2.default.string.isRequired
        }))
      }))
    })).isRequired,
    loading: _propTypes2.default.bool.isRequired
  }).isRequired,
  ruleset: _propTypes2.default.shape({
    startTime: _propTypes2.default.string,
    endTime: _propTypes2.default.string
  }),
  currentAdvertiser: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  }).isRequired
}, _class.defaultProps = {
  scopeEntityType: null,
  aggregationLevel: null,
  selectedEntityIds: null,
  ruleset: {
    startTime: (0, _momentTimezone2.default)(),
    endTime: (0, _momentTimezone2.default)(),
    timezone: 'America/Toronto'
  }
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.toggleModal = function () {
    var _props2 = _this3.props,
        ruleSettingsActions = _props2.ruleSettingsActions,
        currentAdvertiser = _props2.currentAdvertiser,
        entityHierarchy = _props2.entityHierarchy;

    if (!entityHierarchy.data.length) {
      ruleSettingsActions('fetchAdvertiserEntities', currentAdvertiser.id);
    }
    _this3.setState(function (prevState, props) {
      return { modalVisible: !prevState.modalVisible };
    });
  };

  this.onEntityScopeFormSubmit = function (values, isValid) {
    _this3.setState({ entityScopeFormIsValid: isValid, modalVisible: !isValid, submitEntityScopeForm: false }, function () {
      if (values && isValid) {
        var selectedEntityIds = values.selectedEntityIds,
            scopeEntityType = values.scopeEntityType,
            aggregationLevel = values.aggregationLevel;


        if (selectedEntityIds || scopeEntityType) {
          _this3.props.ruleSettingsActions('updateEntityScope', {
            scopeEntityType: scopeEntityType,
            selectedEntityIds: selectedEntityIds
          });
        }

        if (aggregationLevel) {
          _this3.props.ruleSettingsActions('updateRuleSettings', {
            aggregationLevel: {
              value: aggregationLevel
            }
          });
        }
      }
    });
  };

  this.submitEntityScopeForm = function () {
    _this3.setState({ submitEntityScopeForm: true });
  };

  this.scheduleFieldTooltip = _react2.default.createElement(
    _antd.Tooltip,
    {
      key: 'schedule-field-tooltip',
      placement: 'top',
      title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'ruleSettings.schedule.field.tooltip',
        defaultMessage: 'Rules use the Rule Set schedule unless otherwise specified.'
      })
    },
    _react2.default.createElement(_antd.Icon, { type: 'info-circle-o' })
  );

  this.initializeForm = function () {
    var props = _this3.props;

    var specificDateRange = props.ruleSettings.dataRangeAbsoluteStart && props.ruleSettings.dataRangeAbsoluteEnd ? [(0, _momentTimezone2.default)(props.ruleSettings.dataRangeAbsoluteStart), (0, _momentTimezone2.default)(props.ruleSettings.dataRangeAbsoluteEnd)] : [];
    var defaultStartTime = props.ruleSettings.startTime ? _momentTimezone2.default.tz(props.ruleSettings.startTime, props.ruleset.timezone) : null;
    var defaultEndTime = props.ruleSettings.endTime ? _momentTimezone2.default.tz(props.ruleSettings.endTime, props.ruleset.timezone) : null;

    props.form.setFieldsInitialValue({
      name: props.ruleSettings.name,
      frequency: props.ruleSettings.frequency,
      schedule: [defaultStartTime, defaultEndTime],
      status: props.ruleSettings.status,
      dataRangeRelative: props.ruleSettings.dataRangeRelative,
      specificDateRange: specificDateRange,
      lastNDays: props.ruleSettings.lastNDays,
      attributionClickWindow: props.ruleSettings.attributionClickWindow !== null ? props.ruleSettings.attributionClickWindow.toString() : null,
      attributionViewWindow: props.ruleSettings.attributionViewWindow !== null ? props.ruleSettings.attributionViewWindow.toString() : null,
      scheduleType: props.ruleSettings.scheduleType
    });
  };

  this.isFormValid = function () {
    var isValid = 1;
    var _props$ruleSettings2 = _this3.props.ruleSettings,
        dataRangeRelative = _props$ruleSettings2.dataRangeRelative,
        scheduleType = _props$ruleSettings2.scheduleType;

    var errors = _this3.props.form.getFieldsError();

    if (dataRangeRelative !== 'DATE_RANGE') errors.specificDateRange = null;
    if (dataRangeRelative !== 'LAST_N_DAYS') errors.lastNDays = null;
    if (scheduleType === 'ONGOING') errors.schedule = null;

    forIn(errors, function (value, key) {
      if (value && value.length > 0) {
        isValid *= 0;
      }
    });
    return isValid === 1;
  };
}, _temp);


var RuleSettingsForm = _antd.Form.create({
  onFieldsChange: function onFieldsChange(props, changedFields) {
    props.ruleSettingsActions('updateRuleSettings', changedFields);
  }
})(RuleSettings);

exports.default = RuleSettingsForm;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/RuleSettings.js
// module id = 3769
// module chunks = 4